// import { useEffect, useRef } from "react";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// // Register the required components
// ChartJS.register(ArcElement, Tooltip, Legend);

// const WalletActivityChart = () => {
//   const chartRef = useRef<any>(null);

//   // Cleanup chart on unmount
//   useEffect(() => {
//     return () => {
//       if (chartRef.current) {
//         chartRef?.current.destroy();
//       }
//     };
//   }, []);

//   const chartData = {
//     labels: ["Top up", "Withdraw", "Send"],
//     datasets: [
//       {
//         data: [20, 3, 1],
//         backgroundColor: ["#6226EF", "#0000ff", "#ff0000"],
//         borderColor: ["#ffffff", "#ffffff", "#ffffff"],
//         borderWidth: 1,
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         labels: {
//           boxWidth: 10,
//         },
//         position: "bottom" as const,
//       },
//       tooltip: {
//         callbacks: {
//           label: function (tooltipItem: any) {
//             return `${tooltipItem.label}: ${tooltipItem.raw}m`;
//           },
//         },
//       },
//     },
//   };

//   return (
//     <div className="w-[70%] h-[300px] mx-auto flex justify-center">
//       <Doughnut ref={chartRef} data={chartData} options={chartOptions} />
//     </div>
//   );
// };

// export default WalletActivityChart;




import { useEffect, useRef } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

interface ActivityData {
  month: string;
  credits: number;
  debits: number;
}

interface WalletActivityChartProps {
  activityData: ActivityData[];
}

const WalletActivityChart = ({ activityData }: WalletActivityChartProps) => {
  const chartRef = useRef<any>(null);

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef?.current.destroy();
      }
    };
  }, []);

  // Sum up total credits and debits across all months
  const totalCredits = activityData.reduce((sum, d) => sum + d.credits, 0);
  const totalDebits = activityData.reduce((sum, d) => sum + d.debits, 0);

  // If no data yet, show zeros so chart doesn't break
  const hasData = totalCredits > 0 || totalDebits > 0;

  const chartData = {
    labels: ["Top up (Credits)", "Withdrawals (Debits)"],
    datasets: [
      {
        data: hasData ? [totalCredits, totalDebits] : [1, 0], // fallback to avoid empty chart
        backgroundColor: ["#6226EF", "#0000ff"],
        borderColor: ["#ffffff", "#ffffff"],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          boxWidth: 10,
        },
        position: "bottom" as const,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const value = tooltipItem.raw as number;
            return `${tooltipItem.label}: ₦${value.toLocaleString()}`;
          },
        },
      },
    },
  };

  return (
    <div className="w-[70%] h-[300px] mx-auto flex flex-col justify-center items-center">
      {!hasData && (
        <p className="text-xs text-gray-400 italic mb-2">No activity data yet</p>
      )}
      <Doughnut ref={chartRef} data={chartData} options={chartOptions} />
    </div>
  );
};

export default WalletActivityChart;